// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { IlliquidAsset } from '@shared/data-access/types/engine-types';
import {
  TagObjectType,
  type TagsByObjectKey,
  type TagsByObjectEntry,
} from '@shared/data-access/interfaces/redux/tags-management-state-types';
import { generateAssignmentId } from '@shared/data-access/slices/tags-management';

export interface FilterIlliquidAssetsByTagParams {
  readonly assets: readonly IlliquidAsset[];

  readonly selectedTag: string | undefined;

  readonly tagsByObject: Map<TagsByObjectKey, TagsByObjectEntry>;
}

export const filterIlliquidAssetsByTag = (
  params: FilterIlliquidAssetsByTagParams,
): IlliquidAsset[] => {
  const { assets, selectedTag, tagsByObject } = params;

  const isAll = !selectedTag;

  if (isAll) return [...assets];

  return assets.filter(
    asset =>
      tagsByObject
        .get(
          generateAssignmentId(
            TagObjectType.IlliquidAsset,
            String(asset.id),
          ) as TagsByObjectKey,
        )
        ?.tags.some(tag => tag.tag_id.toString() === selectedTag) ?? false,
  );
};
